import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceAuth {
    lookupService = new APIServiceLookUp();

    async userRegistertion(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/cutomerRegister`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userLogin(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/cutomerLogin`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userVerify(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/cutomerVerify`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userResend(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/phoneResend`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userPhoneVerify(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/phoneVerify`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userGetById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}customer/getCutomerById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userUpdate(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}customer/updateCustomer`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async checkUser(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}customer/checkCustomer`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async deactiveUser(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}customer/deactiveCustomer`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}